<script>
    import app from "../lib/stores/app.js";
    import {
        PAYMENT_TYPE,
        RESERVATION_STATUS,
        ROUTE_TYPE,
        SUMMARY_TITLES,
        TRANSFER_STATUSES
    } from "../lib/js/constants.js";
    import {DMY_HM, formatPrice} from "../lib/js/utils.js";

    export let reservation;

    const start_price = Number(reservation.start_price);
    const price = Number(reservation.price);
    let payment = Number(reservation.payment);

    const routeTitle = (route_type) => {
        if (route_type == ROUTE_TYPE.ARRIVAL) {
            return SUMMARY_TITLES['arrival'];
        }

        if (route_type == ROUTE_TYPE.DEPARTURE) {
            return SUMMARY_TITLES['departure'];
        }

        if (route_type == ROUTE_TYPE.TRANSFER) {
            return SUMMARY_TITLES['location'];
        }

        // if (route_type == ROUTE_TYPE.TOUR) {
        //     return "Private Tour";
        // }

        return SUMMARY_TITLES[route.route_type];
    }

    const routeStatus = (status_id) => {
        return TRANSFER_STATUSES[status_id];
    }
</script>

<div class="details-list mb-4">
    {#if reservation.ref}
        <div class="details-row">
            <div class="details-heading">Booking Reference</div>
            <div class="details-content">{reservation.ref}</div>
        </div>
    {/if}
    {#if reservation?.status == RESERVATION_STATUS.COMPLETED && reservation?.order_id}
        <div class="details-row">
            <div class="details-heading">Order Id:</div>
            <div class="details-content">{reservation.order_id}</div>
        </div>
    {/if}
    {#if reservation.agent_email}
        <div class="details-row">
            <div class="details-heading">
                Agent Email
            </div>
            <div class="details-content">{reservation.agent_email}</div>
        </div>
    {/if}
    <div class="details-row">
        <div class="details-heading">
            {#if reservation.payment_type == PAYMENT_TYPE.BANK}
                Guest Name
            {:else}
                Name
            {/if}
        </div>
        <div class="details-content">{reservation.fullname}</div>
    </div>
    <div class="details-row">
        <div class="details-heading">
            {#if reservation.payment_type == PAYMENT_TYPE.BANK}
                Guest Phone
            {:else}
                Phone
            {/if}
        </div>
        <div class="details-content">{reservation.phone}</div>
    </div>
    <div class="details-row">
        <div class="details-heading">
            {#if reservation.payment_type == PAYMENT_TYPE.BANK}
                Guest Email
            {:else}
                Email
            {/if}
        </div>
        <div class="details-content">{reservation.email}</div>
    </div>
    {#if reservation.room_no}
        <div class="details-row">
            <div class="details-heading">Room No</div>
            <div class="details-content">{reservation.room_no}</div>
        </div>
    {/if}
</div>

{#each reservation.routes as route, index}
    <div class="details-list mb-4">
        {#if route.route_type == ROUTE_TYPE.TOUR}

            <div class="details-row">
                <div class="details-heading">
                    {#if reservation.routes.length > 1}
                        {index + 1}.
                    {/if}
                    Private tour
                </div>
                <div class="details-content fw-semibold">
                    {route.tour_name}
                    <button class="btn btn-light btn-sm p-1 ms-1" on:click={() => $app.tour_id = route.tour_id}>View
                        details
                    </button>
                </div>
            </div>
            <div class="details-row">
                <div class="details-heading">Pickup from</div>
                <div class="details-content">{route.pickup_name}</div>
            </div>

        {:else}

            <div class="details-row">
                <div class="details-heading">
                    {#if reservation.routes.length > 1}
                        {index + 1}.
                    {/if}
                    {routeTitle(route.route_type)}
                </div>
                <div class="details-content fw-semibold">{route.pickup_name} → {route.drop_name}</div>
            </div>

            {#if route.pickup_address}
                <div class="details-row">
                    <div class="details-heading">Pickup address</div>
                    <div class="details-content">{route.pickup_address}</div>
                </div>
            {:else if route.drop_address}
                <div class="details-row">
                    <div class="details-heading">Destination address:</div>
                    <div class="details-content">{route.drop_address}</div>
                </div>
            {/if}

        {/if}
        <div class="details-row">
            <div class="details-heading">Date & Time</div>
            <div class="details-content">
                {#if route.transfer_at}
                    {DMY_HM(route.transfer_at)}
                {:else}
                    <span class="text-gray">Exact date arranged after booking</span>
                {/if}
            </div>
        </div>
        {#if route.room_no}
            <div class="details-row">
                <div class="details-heading">Room no</div>
                <div class="details-content">{route.room_no}</div>
            </div>
        {/if}
        {#if route.flight_no}
            <div class="details-row">
                <div class="details-heading">Flight Number or Ferry</div>
                <div class="details-content">{route.flight_no}</div>
            </div>
        {/if}
        {#if reservation.status == RESERVATION_STATUS.COMPLETED}
            <div class="details-row">
                <div class="details-heading">Status</div>
                <div class="details-content">{routeStatus(route.status_id)}</div>
            </div>
        {/if}
    </div>
{/each}
<div class="details-list">
    <div class="details-row mt-3">
        <div class="details-heading">Passengers</div>
        <div class="details-content">
            <span class="detail-item">Adults <span class="times">x</span> {reservation.adults}</span>
            {#if reservation.children > 0}
                <span class="detail-item">Children <span class="times">x</span> {reservation.children}</span>
            {/if}
            {#if reservation.infants > 0}
                <span class="detail-item">Infants <span class="times">x</span> {reservation.infants}</span>
            {/if}
        </div>
    </div>
    {#if reservation.booster_seats + reservation.baby_seats + reservation.infant_seats > 0}
        <div class="details-row">
            <div class="details-heading">Extras</div>
            <div class="details-content">
                {#if reservation.baby_seats > 0}
                    <span class="detail-item">Baby seats <span class="times">x</span> {reservation.baby_seats}</span>
                {/if}
                {#if reservation.booster_seats > 0}
                    <span class="detail-item">Boosters <span class="times">x</span> {reservation.booster_seats}</span>
                {/if}
                {#if reservation.infant_seats > 0}
                    <span class="detail-item">Infant seats <span
                            class="times">x</span> {reservation.infant_seats}</span>
                {/if}
            </div>
        </div>
    {/if}
    <div class="details-row">
        <div class="details-heading">Luggage:</div>
        <div class="details-content">
            {#if reservation.luggage > 0}
                <span class="times">x</span> {reservation.luggage}
            {:else}
                No luggage
            {/if}
        </div>
    </div>
    <div class="details-row">
        <div class="details-heading">Vehicle:</div>
        <div class="details-content">
            {#if reservation.vehicle}
                {reservation.vehicle.name}
                {#if reservation.vehicle.info}
                    <div class="smaller text-gray">
                        {reservation.vehicle.info}
                    </div>
                {/if}
            {/if}
        </div>
    </div>
    {#if reservation.notes}
        <div class="details-row">
            <div class="details-heading">Notes:</div>
            <div class="details-content">{reservation.notes}</div>
        </div>
    {/if}
    <div class="details-row">
        <div class="details-heading">Total price:</div>
        <div class="details-content">
            {#if price > 0}
                {#if start_price > 0}
                    <span class="start-price text-muted">
                        <s>{formatPrice(start_price)}</s>
                    </span>
                {/if}
                <span class="fw-semibold">{formatPrice(price)}</span>
            {:else}
                On request
            {/if}
        </div>
    </div>
    {#if payment > 0}
        <div class="details-row">
            <div class="details-heading">Payment:</div>
            <div class="details-content fw-bold">
                {formatPrice(payment)}
            </div>
        </div>
    {/if}
    {#if reservation?.payment_type == PAYMENT_TYPE.CARD}
        <div class="details-row">
            <div class="details-heading">Payment method:</div>
            <div class="details-content">Debit / Credit Card</div>
        </div>
    {/if}
    {#if reservation?.payment_type == PAYMENT_TYPE.BANK}
        <div class="details-row">
            <div class="details-heading">Payment method:</div>
            <div class="details-content">Bank deposit</div>
        </div>
    {/if}
</div>

<style>
    .details-list {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .details-row {
        display: flex;
        gap: 20px;
        border-bottom: 1px solid #e1e1e1;
        padding-bottom: 8px;
    }

    .details-row:last-child {
        border-bottom: none;
    }

    .details-heading {
        width: 175px;
        font-weight: 500;
        color: #50ba87;
    }

    .details-content {
        flex: 1;
    }

    .detail-item {
        display: inline-block;
        padding-right: 10px;
    }

    .start-price {
        font-size: 0.85rem;
        padding-right: 10px;
    }

    @media (max-width: 991px) {
        .details-row {
            flex-direction: column;
            gap: 0;
        }

        .details-heading {
            width: 100%;
            font-size: 12px;
        }
    }
</style>